<template>
  <div id="footer" :class="ChangeFooterClass">
    <div class="theme-footer" :class="DisplayHiddenClass" id="mainFooter">
      <div class="container _ph-mob-0">
        <div class="row row-eq-height row-mob-full mt-20" data-gutter="60">
          <div class="col-md-3">
            <div class="theme-footer-section theme-footer-">
              <router-link
                to="/">
                <img
                  class="img-responsive"
                  src="@/assets/img/logo-tourhouse-md.png"
                  alt="Logo Tour House"
                  title="Ir para Home" >
              </router-link>
              <div class="theme-footer-brand-text mt-20">
                <p>A Tour House pesquisa centenas de sites de viagens ao mesmo tempo para encontrar as melhores ofertas de passagens aéreas, hotéis baratos e estadias.</p>
              </div>
            </div>
          </div>
          <div class="col-md-5">
            <div class="row">
              <div class="col-md-4">
                <div class="theme-footer-section theme-footer-">
                  <h5 class="theme-footer-section-title">Institucional</h5>
                  <ul class="theme-footer-section-list">
                    <li>
                      <a href="https://tourhouse.com.br/institucional/fale-conosco/" target="_blank">Fale conosco</a>
                    </li>
                    <li>
                      <a
                        href="/PoliciesPrivacy"
                        target="_blank"
                      >Política de Privacidade</a>
                    </li>
                    <li>
                      <a
                        href="/TermsConditions"
                        target="_blank"
                      >Termos e condições</a>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="col-md-4">
                <div class="theme-footer-section theme-footer-">
                  <h5 class="theme-footer-section-title">
                    <i class="fa fa-map-marker" aria-hidden="true"></i> Endereço
                  </h5>
                  <ul class="theme-footer-section-list">
                    <li>
                      <div class="theme-footer-brand-text">
                        <p>Rua da Consolação, 247
                          <br>9º Andar - Centro - São Paulo
                        </p>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="col-md-4">
                <div class="theme-footer-section theme-footer-">
                  <h5 class="theme-footer-section-title">
                    <i class="fa fa-phone" aria-hidden="true"></i> Telefone
                  </h5>
                  <ul class="theme-footer-section-list">
                    <li>
                      <div class="theme-footer-brand-text">
                        <p>+55 (11) 3156-7734</p>
                      </div>
                    </li>
                  </ul>
                  <br/>
                  <h5 class="theme-footer-section-title">
                    <i class="fa fa-envelope" aria-hidden="true"></i> E-mail
                  </h5>
                  <ul class="theme-footer-section-list">
                    <li>
                      <div class="theme-footer-brand-text">
                        <p>experience@tourhouse.com.br</p>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="row">
              <div class="col-md-4">
                <div class="theme-footer-section theme-footer- logos-footer center-block">
                  <a href="http://www.abav.com.br/" target="_blank">
                    <img
                      class="img-responsive"
                      src="@/assets/img/logo-abav.png"
                      alt="Logo ABAV - Associação Brasileira de Agências de Viagens"
                      title="Associação Brasileira de Agências de Viagens"
                    >
                  </a>
                </div>
              </div>
              <div class="col-md-4">
                <div class="theme-footer-section theme-footer- logos-footer center-block">
                  <a href="http://www.iata.org/" target="_blank">
                    <img
                      class="img-responsive"
                      src="@/assets/img/logo-iata.png"
                      alt="Logo IATA - The International Air Transport Association"
                      title="IATA - The International Air Transport Association"
                    >
                  </a>
                </div>
              </div>
              <div class="col-md-4">
                <div class="theme-footer-section theme-footer- logos-footer center-block">
                  <img
                    class="img-responsive"
                    src="@/assets/img/logo-comodo.png"
                    alt="Logo Comodo Secure"
                    title="Comodo Secure"
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="theme-copyright">
      <div class="container">
        <div class="row">
          <div class="col-md-6">
            <p class="theme-copyright-text">
              Copyright &copy; 2019. Todos os direitos reservados - Desenvolvido por
              <a
                href="http://www.itmss.com.br/"
                target="_blank"
              >ITM Tecnologia</a>
            </p>
          </div>
          <div class="col-md-6">
            <ul class="theme-copyright-social">
              <li>
                <a href="https://www.facebook.com/tourhouse/" target="_blank">
                  <i class="fa fa-facebook"></i>
                </a>
              </li>
              <li>
                <a href="https://www.linkedin.com/company/tour-house-viagens-e-turismo-ltda/" target="_blank">
                  <i class="fa fa-linkedin"></i>
                </a>
              </li>
              <li>
                <a href="https://www.instagram.com/tour_house_viagens/" target="_blank">
                  <i class="fa fa-instagram"></i>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    ChangeFooterClass: function() {
      if (["/login", "/password_reset", "/forgot_password", "/cards"].includes(window.location.pathname)) {
        return "fixedFooter";
      }
      else{
        return "";
      }
    },
    DisplayHiddenClass: function() {
      if (["/login", "/password_reset", "/forgot_password", "/signup"].includes(window.location.pathname)) {
        return "hideFooterElement";
      }
      else{
        return "";
      }
    }
  }
};
</script>

<style scoped>
.theme-footer-section {
  padding: 15px 0 !important;
  position: relative;
}
.logo-etrip-footer {
  width: 160px;
  margin-bottom: 10px;
}
.logos-footer {
  width: 90px;
}
.hideFooterElement{
display: none;
}
@media only screen and (min-width: 320px) {
  .fixedFooter {
    position: relative;
    width: 100%;
    bottom: 0;
    z-index: 9;
  }
}

@media only screen and (min-width: 480px) {
  .fixedFooter {
    position: relative;
    width: 100%;
    bottom: 0;
    z-index: 9;
  }
}

@media only screen and (min-width: 768px) {
  .fixedFooter {
    position: relative;
    width: 100%;
    bottom: 0;
    z-index: 9;
  }
}

@media only screen and (min-width: 992px) {
  .fixedFooter {
    position: absolute;
    width: 100%;
    bottom: 0;
    z-index: 9;
  }
}

@media only screen and (min-width: 1200px) {
  .fixedFooter {
    position: absolute;
    width: 100%;
    bottom: 0;
    z-index: 9;
  }
}
#footer {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
</style>
